<plex-layout [main]="showSidebar? 8 : 12">
    <plex-layout-main>
        <plex-title main titulo="CAMAS PROVINCIALES">
            <plex-button label="volver" type="danger" size="md" position="left" routerLink='/inicio'></plex-button>
            <plex-button class="ml-1" title="Actualizar fecha" titlePosition="left" icon="reload" type="info" size="md"
                         (click)="setFecha()">
            </plex-button>
        </plex-title>

        <plex-wrapper>
            <plex-select [(ngModel)]="selectedOrganizacion" name="organizacion" tmOrganizaciones label="Organización"
                         placeholder="Seleccione la organización" (change)="filtrar()">
            </plex-select>
            <plex-select name="unidadOrganizativa" [data]="unidadesOrganizativas" label="Unidad Organizativa"
                         idField="conceptId" labelField="term" [(ngModel)]="selectedUnidadOrganizativa"
                         (change)="filtrar()">
            </plex-select>
            <plex-datetime grow="1" type="datetime" [(ngModel)]="fecha" name="fecha" label="Fecha" [max]="fechaLimite"
                           [disabled]="true">
            </plex-datetime>
            <plex-select [(ngModel)]="capaSeleccionada" name="capa" label="Capa" [data]="capa" (change)="filtrar()">
            </plex-select>
        </plex-wrapper>

        <ng-container *ngIf="camasEstados$ | async as camasEstados">
            <plex-grid size="md" [cols]="3">
                <plex-card *ngFor="let efector of camasEstados" [selectable]="true" (click)="verDetalle(efector)"
                           [selected]="efector.organizacion._id === efectorSelected?._id">
                    <div class="contenido-card">
                        <div class="icono-hospital mb-0">
                            <plex-icon name="hospital" size="xl" type="info"></plex-icon>
                        </div>
                        <div class="mb-3">
                            <plex-label titulo="{{efector.organizacion.nombre}}" size="xl" class="text-center">
                            </plex-label>
                            <hr class="my-1 w-50">
                        </div>
                        <div class="fila-camas">
                            <div class="col-cama">
                                <plex-icon size="xl" name="cama" type="info" class="size-icon"></plex-icon>
                                <plex-label size="xl" type="info" titulo="{{efector.totalCamas}}"
                                            subtitulo="Total de camas" class="margen-left-10">
                                </plex-label>
                            </div>
                            <div class="col-cama">
                                <plex-icon size="xl" name="cama" type="success" class="size-icon"></plex-icon>
                                <plex-label size="xl" type="success" titulo="{{efector.camasDisponibles}}"
                                            subtitulo="Camas disponibles" class="margen-left-10">
                                </plex-label>
                            </div>
                        </div>
                        <div class="fila-camas">
                            <div class="col-cama">
                                <plex-icon size="xl" name="cama-paciente" type="warning" class="size-icon"></plex-icon>
                                <plex-label size="xl" type="warning" titulo="{{efector.camasOcupadas}}"
                                            subtitulo="Camas ocupadas" class="margen-left-10">
                                </plex-label>
                            </div>
                            <div class="col-cama">
                                <plex-icon size="xl" name="cama-candado" type="default" class="size-icon"></plex-icon>
                                <plex-label size="xl" type="default" titulo="{{efector.camasBloqueadas}}"
                                            subtitulo="Camas bloqueadas" class="margen-left-10">
                                </plex-label>
                            </div>
                        </div>
                    </div>
                </plex-card>
            </plex-grid>
            <div *ngIf="!camasEstados?.length" justify="center" class="mt-5">
                <plex-label class="flex-column" icon="informacion" size="xl" direction="column" type="info"
                            titulo="No se encontraron camas disponibles">
                </plex-label>
            </div>
        </ng-container>

    </plex-layout-main>
    <plex-layout-sidebar type="invert">
        <plex-title titulo="DETALLE EFECTOR" size="md">
            <plex-button size="sm" type="danger" icon="close" tooltip="Cerrar" (click)="closeSidebar()"></plex-button>
        </plex-title>
        <ng-container *ngIf="efectorSelected">
            <plex-detail>
                <plex-icon name="hospital" type="info"></plex-icon>
                <div title>{{efectorSelected.organizacion.nombre}}</div>
                <plex-label titulo="Capa: {{ capaSeleccionada.nombre }}" size="lg" subtitulo="">
                </plex-label>
            </plex-detail>
            <ng-container *ngFor="let unidadOrganizativa of efectorSelected.unidadesOrganizativas">
                <plex-accordion>
                    <plex-panel class="lista-panel">
                        <div plex-accordion-title>
                            <span class="d-flex justify-content-between align-items-center">
                                <strong> {{unidadOrganizativa.term}}</strong>
                            </span>
                        </div>
                        <div plex-accordion-content>
                            <div class="d-flex">
                                <div class="flex-1 mr-2">
                                    <plex-label size="lg">Total de camas: {{unidadOrganizativa.totalCamas}}</plex-label>
                                    <plex-label size="lg">Camas Ocupadas:
                                        {{unidadOrganizativa.camasOcupadas}}</plex-label>
                                </div>
                                <div class="flex-1 ml-5">
                                    <plex-label size="lg">Camas Disponibles:
                                        {{unidadOrganizativa.camasDisponibles}}
                                    </plex-label>
                                    <plex-label size="lg">Camas Bloqueadas:
                                        {{unidadOrganizativa.camasBloqueadas}}
                                    </plex-label>
                                </div>
                            </div>
                        </div>
                    </plex-panel>
                </plex-accordion>
            </ng-container>
        </ng-container>
    </plex-layout-sidebar>
</plex-layout>